export default __webpack_public_path__ + "static/media/WitbookingAI_Mobile.5293eb66.png";